import React from "react";

const SharedInput = ({ name, id, inputType, inputChange, value, keypress }) => {
  return (
    <input
      id={id}
      placeholder={name}
      name={id}
      type={inputType}
      className="form-control"
      onChange={(e) => inputChange(e)}
      value={value}
      onKeyPress={keypress !== undefined ? keypress : null} 
    />
  );
};

export default SharedInput;
